import { $uniDebug } from "../uni-debug.module"
import { IController } from "angular"

/**
 * Captura una pulsación tecla Esc
 */
class EscKey implements ng.IDirective {
  link(scope: ng.IScope, element: JQLite, attrs: ng.IAttributes, ctrls: IController | undefined) {
    element.bind("keydown keypress", function(event) {
      if (event.which === 27) {
        // 27 = esc key
        scope.$apply(function() {
          scope.$eval(attrs.escKey)
        })

        event.preventDefault()
      }
    })
  }
}

$uniDebug.directive("escKey", [() => new EscKey()])
